import { NgModule } from "@angular/core";

import { SharedModule } from '../shared/shared.module';
import { NofeshRouting } from "./nofesh.routes";

import { MyDatePickerModule } from 'mydatepicker';

import { NofeshAdminHomeComponent } from "./admin/home/home.component";
import { AddNofeshComponent } from "./admin/add-nofesh/add-nofesh.component";
import { PriceComponent } from "./admin/add-nofesh/price.component";
import { NofashimComponent } from "./admin/nofashim/nofashim.component";
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from "./home/header-panel/header-panel.component";
 import { NofeshDetailsComponent } from "./nofesh-details/nofesh-details.component";
import { OrderNofeshComponent } from "./order/order-nofesh.component";
//import { NofeshPricesComponent } from "./nofesh-prices/nofesh-prices.component";
import { NirshamimComponent } from "./nirshamim/nirshamim.component";
import { NofeshPaymentComponent } from "./order/nofesh-payment.component";

//import { NofeshUploadsComponent } from "./nofesh-uploads/nofesh-uploads.component";

import { TashlumimComponent } from './tashlumim/tashlumim.component';
import { EndRishumComponent } from "./nofesh-end-rishum/end-rishum.component";
// import { ModalComponent } from '../shared/modal/modal.component';
import { NofeshStatusPipe } from './../shared/pipes/custom-nofesh-status.pipe';
import { MatTooltipModule, MatButtonModule } from "@angular/material";

@NgModule({
    imports: [NofeshRouting, SharedModule, MyDatePickerModule,MatTooltipModule,
        MatButtonModule],
    declarations: [
        NofeshAdminHomeComponent,
        AddNofeshComponent,
        PriceComponent,
        NofashimComponent,
        HomeComponent,
        HeaderComponent,
         NofeshDetailsComponent,
        OrderNofeshComponent,
       // NofeshPricesComponent,
        NirshamimComponent,
        NofeshPaymentComponent,
       // NofeshUploadsComponent,
        TashlumimComponent,
        EndRishumComponent,
       // ModalComponent, 
        NofeshStatusPipe
    ],
    exports: [NirshamimComponent,NofeshStatusPipe]
})

export class NofeshModule { }
